export var borderRadius = function borderRadius(radius) {
  return function (_ref) {
    var theme = _ref.theme;

    if (theme) {
      var currentTheme = theme.armor || theme;

      if (radius in currentTheme.shape.borderRadius) {
        return currentTheme.shape.borderRadius[radius];
      }

      return radius;
    }

    return radius;
  };
};